import { use } from 'react';
import { type UserInfo, UserInfoContext } from '../user-info-context';

export const useUserInfo = (): UserInfo | undefined => {
  const { userInfo } = use(UserInfoContext);
  return userInfo;
};
